import React from "react";
import * as styles from "./styles.module.scss";

const YoutubeIFrame = ({ videoUrl, id }) => {
  const NUMBER_OF_CHARACTERS_IN_YOUTUBE_VIDEO_IDS = 11;

  const youtubeVideoId = videoUrl
    .split(`v=`)[1]
    .substring(0, NUMBER_OF_CHARACTERS_IN_YOUTUBE_VIDEO_IDS);

  const htmlVideoId = id.replace(` `, `-`) || youtubeVideoId;

  return (
    <div className={styles.container} id={htmlVideoId}>
      <div className={styles.videoContainer}>
        <div className={styles.ratioProvider}>
          <iframe
            title={htmlVideoId}
            src={`https://www.youtube.com/embed/${youtubeVideoId}`}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default YoutubeIFrame;
